import Vue from "vue";
import App from "./App.vue";
import Cookies from 'js-cookie'
import router from "./router";
import store from "./store";
import Element from 'element-ui'
import i18n from './lang' // Internationalization
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css'
import './directives/directivesDialog.js'


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;

Vue.use(Element, {
  size: Cookies.get('size') || 'mini',
  i18n: (key, value) => i18n.t(key, value)
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
